/**
 * Kewels — luxury micro-interactions
 * Subtle scroll reveals, parallax, page load. Respects prefers-reduced-motion.
 */

(function () {
  const REDUCED_MOTION = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const MOBILE = () => window.matchMedia('(max-width: 749px)').matches;

  const SKIP_REVEAL_SELECTOR =
    '.hero-cinematic, .collection-luxury__hero, [data-luxury-no-reveal], .announcement-bar-section, .shopify-section-header';

  function initPageLoad() {
    const finish = () => {
      document.body.classList.remove('luxury-is-loading');
      document.body.classList.add('luxury-loaded');
    };

    if (document.readyState === 'complete') {
      window.requestAnimationFrame(finish);
      return;
    }

    window.addEventListener('load', finish, { once: true });
    window.setTimeout(finish, 2800);
  }

  function initLuxuryReveal(root = document) {
    const targets = [];

    root.querySelectorAll('#MainContent .shopify-section').forEach((section) => {
      if (section.matches(SKIP_REVEAL_SELECTOR) || section.querySelector('.hero-cinematic')) return;
      if (section.classList.contains('luxury-reveal--init')) return;
      section.classList.add('luxury-reveal', 'luxury-reveal--section', 'luxury-reveal--init');
      targets.push(section);
    });

    root.querySelectorAll('.footer--luxury:not(.luxury-reveal--init)').forEach((footer) => {
      footer.classList.add('luxury-reveal', 'luxury-reveal--section', 'luxury-reveal--init');
      targets.push(footer);
    });

    if (targets.length === 0) return;

    if (REDUCED_MOTION()) {
      targets.forEach((el) => el.classList.add('luxury-reveal--visible'));
      return;
    }

    const observer = new IntersectionObserver(
      (entries, observerInstance) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('luxury-reveal--visible');
          observerInstance.unobserve(entry.target);
        });
      },
      {
        threshold: 0.12,
        rootMargin: '0px 0px -40px 0px',
      }
    );

    targets.forEach((el) => observer.observe(el));
  }

  function initParallax(root = document) {
    if (REDUCED_MOTION() || MOBILE()) return;

    const elements = Array.from(root.querySelectorAll('[data-luxury-parallax]:not([data-luxury-parallax-bound])'));
    if (elements.length === 0) return;

    elements.forEach((el) => {
      el.dataset.luxuryParallaxBound = 'true';
    });

    let ticking = false;

    const update = () => {
      const viewportCenter = window.innerHeight * 0.5;

      elements.forEach((el) => {
        const rate = parseFloat(el.dataset.luxuryParallax) || 0.05;
        const rect = el.getBoundingClientRect();

        if (rect.bottom < 0 || rect.top > window.innerHeight) return;

        const offset = (rect.top + rect.height * 0.5 - viewportCenter) * rate * -1;

        if (el.classList.contains('collection-luxury__hero')) {
          el.style.backgroundPosition = `center calc(50% + ${offset}px)`;
          return;
        }

        const target = el.querySelector('img, video, .hero-cinematic__image, .hero-cinematic__video') || el;
        target.style.transform = `translate3d(0, ${offset}px, 0) scale(1.03)`;
      });

      ticking = false;
    };

    const onScroll = () => {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    };

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    update();
  }

  function init(root = document) {
    initLuxuryReveal(root);
    initParallax(root);
  }

  document.addEventListener('DOMContentLoaded', () => {
    initPageLoad();
    init();
  });

  document.addEventListener('shopify:section:load', (event) => {
    init(event.target);
  });

  window.LuxuryMicroInteractions = { init };
})();
